const config = require('./config.yaml');
const CPageNav = require('../../index.js');

/**
 * Реализует логику варианта sides компонента page-nav
 */
class CPageNav_sides extends CPageNav {
	constructor() {
		super();
	}

	/**
	 * Инициализация
	 */
	init() {
		this.$pagenavSides = $('.js-pagenav-sides');
		if (this.$pagenavSides.length) {
			this.$pagenavLink = this.$pagenavSides.find($('.b-pagenav__link'));
			// $(document).on('keydown', $.proxy(this, 'checkKeyDown'));
			// $(document).on('touchstart', $.proxy(this, 'removeTouchClass'));
			// this.$pagenavLink.on('touchstart', $.proxy(this, 'touchStart'));
			this.addHelpKey();
		}
	}
}

AR.waitComponents([], () => {
	const cPageNav_sides = new CPageNav_sides();
	// Вызов метода, инициализирующего все существующие события
	cPageNav_sides.init();
	// Добавление в глобальный объект AR.components
	AR.pushComponent(cPageNav_sides, 'cPageNav_sides');
});



// WEBPACK FOOTER //
// ./temp/components/page-nav/.variant/sides/index.js